import { useState, useEffect, Dispatch, SetStateAction } from "react";

export const LOCAL_STORAGE_KEYS = {
  SIDEBAR_STATE: "promptlayer-sidebar-state",
  REQUESTS_TIMEZONE: "requests-page-timezone",
  LAST_WORKSPACE: "lastWorkspace",
  SIDEBAR_SECONDARY_OPEN: "sidebar_secondary_open",
  SIDEBAR_VIEW: "sidebar_view",
  SIDEBAR_WIDTH: "sidebar-width",
  SIDEBAR_FAVORITES_EXPANDED: "sidebar-favorites-expanded",
  SIDEBAR_HOME_EXPANDED: "sidebar-home-expanded",
  SMART_TABLE_RIGHT_PANEL_WIDTH: "smart-table-right-panel-width",
  OBSERVABILITY_SIDEBAR_WIDTH: "observability-sidebar-width",
  PROMPT_OVERVIEW_VIEW_TYPE: "PROMPT_OVERVIEW_VIEW_TYPE",
  ONBOARDING_USECASE: "onboarding_usecase",
  ONBOARDING_PATH: "onboarding_path",
  ONBOARDING_DESTINATION: "onboarding_destination",
  ONBOARDING_WORKSPACE_INTRO_MODAL: "onboarding_workspace_intro_modal",
  OPEN_VIBECHAT_ON_MOUNT: "open_vibechat_on_mount",
  TOUR_PLAYGROUND_VISITED: "tour_playground_visited",
  TOUR_PLAYGROUND_POPOVER_DISMISSED: "tour_playground_popover_dismissed",
} as const;

/** Same-tab signal so sidebar Favorites expands on star/unstar. */
export const SIDEBAR_FAVORITES_EXPAND_EVENT = "sidebar-favorites-expand";

export const expandSidebarFavoritesSection = () => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SIDEBAR_FAVORITES_EXPANDED, JSON.stringify(true));
  } catch {
    // ignore quota / private mode
  }
  window.dispatchEvent(new Event(SIDEBAR_FAVORITES_EXPAND_EVENT));
};

const useLocalStorageState = <T>(
  key: string,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(() => {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // eslint-disable-next-line no-console
      console.error("Error handling local storage set item");
    }
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorageState;
